import React from "react";
import Box from "@material-ui/core/Box";

export const Space: React.FC<{ height?: number }> = ({ height = 60 }) => {
  return <Box height={height} />;
};
